module.exports = __webpack_public_path__ + "static/img/ranking_coin_1.24c12c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ranking_coin_1.png
// module id = OJNZ
// module chunks = 0